import { Radio } from 'antd';
import { OutlineButton } from 'components/UI/Buttons';
import ComponentLacunas from 'models/componentInteraction/ComponentLacunas';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        align-items: center;
        align-self: center;
        justify-self: center;
        flex-direction: column;
        margin: 44px 0px;
        width: 720px;
        gap: 1rem;
    `,

    Header: styled.div`
        background-color: #99e3ff;
        height: 42px;
        width: 100%;
        padding: 8px 16px;
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 18px;
        line-height: 25.2px;
        letter-spacing: 0%;
        vertical-align: middle;
        color: #242424;
    `,

    Content: styled.div`
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 1.4rem;
    `,

    Title: styled.div`
        background-color: #fafafa;
        padding: 16px;
        font-size: auto;
    `,

    Alternativas: styled.div`
        display: flex;
        gap: 1rem;
        background-color: #fafafa;
        padding: 16px;
    `,

    LacunaText: styled.h2`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 18px;
        line-height: 25.2px;
        letter-spacing: 0%;
        vertical-align: middle;
    `,

    TextFeedback: styled.h1`
        font-family: 'Barlow';
        font-weight: 600;
        font-size: 22px;
        line-height: 26.4px;
        letter-spacing: 0%;
        vertical-align: middle;
    `,
};

interface IComponentLacunaPublic {
    dados: ComponentLacunas;
}

const ComponentLacunaPublic: React.FC<IComponentLacunaPublic> = ({ dados }) => {
    const [lacuna, setLacuna] = useState<ComponentLacunas | null>(null);
    const [alternativaSelecionada, setAlternativaSelecionada] = useState<number>(-1);

    //feeback
    const [feedbackOpen, setFeedBackOpen] = useState<boolean>(false);

    function preencherLacunasComEstilo(): string {
        let index = 0;

        const texto = lacuna?.text ?? '';
        const alternativa = lacuna?.alternativas?.find(alt => alt.correct);
        const alternativaCorrect = alternativa ? JSON.parse(alternativa.alternativa || '[]') : [];

        return texto.replace(/_+/g, () => {
            const palavra = alternativaCorrect[index++];
            return palavra !== undefined ? `<span style="color: green; font-weight: bold">${palavra}</span>` : '';
        });
    }

    function clear() {
        setAlternativaSelecionada(-1);
        setFeedBackOpen(false);
    }

    useEffect(() => {
        if (dados) setLacuna(dados);
    }, [dados]);

    return (
        <Styled.Container>
            {feedbackOpen ? (
                <>
                    <Styled.Header>Resposta correta:</Styled.Header>
                    <Styled.TextFeedback dangerouslySetInnerHTML={{ __html: preencherLacunasComEstilo() }} />
                    {dados.textAux != null && dados.textAux.length > 0 && (
                    <Styled.Alternativas style={{ fontSize: 18 }}>
                        {dados.textAux}
                    </Styled.Alternativas>

                    )}
                    {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <OutlineButton style={{ width: '220px' }} onClick={clear}>
                            Tentar novamente
                        </OutlineButton>
                    </div> */}
                </>
            ) : (
                <>
                    <Styled.Header>Escolha a opção certa para preencher as lacunas</Styled.Header>
                    <Styled.Content>
                        <Styled.Title dangerouslySetInnerHTML={{ __html: dados.text }} />
                        {lacuna?.alternativas.map((alt, indexAlt) => {
                            const listLacunas = JSON.parse(alt.alternativa) as string[];

                            return (
                                <Styled.Alternativas key={indexAlt}>
                                    <Radio
                                        name="lacuna"
                                        checked={alt.codigo === alternativaSelecionada}
                                        onChange={() => setAlternativaSelecionada(alt.codigo)}
                                    />
                                    {listLacunas &&
                                        listLacunas.length > 0 &&
                                        listLacunas.map((text, indexLacunas) => (
                                            <div key={indexLacunas} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                <div
                                                    style={{
                                                        width: '22px',
                                                        border: '1px solid gray',
                                                        height: 1,
                                                        display: indexLacunas === 0 ? 'none' : '',
                                                    }}
                                                />
                                                <Styled.LacunaText>{text}</Styled.LacunaText>
                                            </div>
                                        ))}
                                </Styled.Alternativas>
                            );
                        })}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ButtonHomeV2 style={{ width: '220px' }} onClick={() => setFeedBackOpen(true)}>
                                Enviar
                            </ButtonHomeV2>
                        </div>
                    </Styled.Content>
                </>
            )}
        </Styled.Container>
    );
};

export default ComponentLacunaPublic;
